module.exports = __webpack_public_path__ + "media/images/logo-simple-4894a2538d97ab12941023d888353d1e.svg";